module.exports = __webpack_public_path__ + "static/media/bg-registration.367f36f9.png";